const icon = require('vue-svgicon');
icon.register({
    'lens-computer': {
        width: 52,
        height: 48,
        viewBox: '0 0 52 48',
        data: `<circle pid="0" cx="20" cy="24" r="19.4" _stroke="#000" stroke-width="1.2"/><path pid="1" d="M22.125 30.31h-.248l-.175.174-6.102 6.072V13.444l16.947 16.865H22.125z" _stroke="#000" stroke-width="1.2"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M10.998 25.8H.078c.036.404.084.804.144 1.2h10.776c1.403 0 2.749-.24 4-.683v-1.282a10.77 10.77 0 01-4 .765zm10.297-7.533l.945.94c.49-1.309.758-2.727.758-4.207V4.224c-.396-.06-.796-.108-1.2-.144V15c0 1.139-.176 2.237-.503 3.267z" _fill="#000"/>`,
    },
});
